<script>
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { loginUser } from "../store";
import { postJson } from '../services';
import Config from '../config.json';

export let title;
export let subtitle;

const navigate = useNavigate();
const location = useLocation();

let email = '';
let first = '';
let last = '';
let code = '';
let password = '';
let passwordConfirm = '';
let org = '';
let orgTitle = '';

let loading = false;
let error;
let errorRef;

async function submit() {
  error = undefined
  
  if (!first.trim()) {
    error = "Please enter your first name";
  } else if (!last.trim()) {
    error = "Please enter your last name";
  } else if (!email.trim() || email.indexOf('@') === -1) {
    error = "Please enter your email";
  } else if (!code.trim()) {
    error = "Please enter your ticket code";
  } else if (!org.trim()) {
    error = 'Please provide your organization';
  } else if (!orgTitle.trim()) {
    error = 'Please provide your organization title';
  } else if (password.length < 6) {
    error = "Password must be at least 6 characters";
  } else if (password !== passwordConfirm) {
    error = "Passwords do not match";
  }

  if (error) {
    window.scrollTo({top: errorRef.offsetTop, behavior: 'smooth'});
    return;
  }

  loading = true;

  try {
    const {token, id} = await postJson('ticketing-set-password', {companyId: Config.companyId, eventId: Config.eventId, email, first, last, code, password, orgTitle, org});
    localStorage.setItem('token', token)
    loginUser(id, token, email, first, last);
    navigate('/', { replace: true });
  } catch (e) {
    error = e.message;
  } finally {
    loading = false;
  }
}

$: {
  const params = new URLSearchParams($location.search);
  const data = params.get('t')
  if (data) {
    try {
      ({first, last, email, code} = JSON.parse(atob(data)));
    } catch (e) {}
  }
}
</script>

<div class="login-title">
  {@html title}
</div>

<div class="login-subtitle">
  {@html subtitle}
  
  <div class='mt-4'>Not registered? <a style='color: #3f37c9' href='/tickets'>Buy tickets</a></div>
</div>

<form on:submit|preventDefault={submit} bind:this={errorRef}>
  {#if error}
    <div class="error-box mb-4">
      {error}
    </div>
  {/if}

  <div class="rowtocol mb-4">
    <div class="col flex-1">
      <div class="form-label">First name</div>
      <input bind:value={first} type="text" name="firstname" />
    </div>
    <div class="gutter" />
    <div class="col flex-1">
      <div class="form-label">Last name</div>
      <input bind:value={last} type="text" name="lastname" />
    </div>
  </div>
  
  <div class='mb-4'>
    <label for="email" class="form-label">Email</label>
    <div class="mt-1">
      <input bind:value={email} class='w-full' id="email" name="email" type='text'>
    </div>
  </div>

  <div class='mb-4'>
    <label for="ticketCode" class="form-label">Ticket Code</label>
    <div class="mt-1">
      <input bind:value={code} class='w-full' id="ticketCode" name="ticketCode" type='text'>
    </div>
  </div>

  <div class="rowtocol mb-4">
    <div class="col flex-1">
      <div class="form-label">Organization *</div>
      <input bind:value={org} type="text" name="organization" />
    </div>
    <div class="gutter" />
    <div class="col flex-1">
      <div class="form-label">Title *</div>
      <input bind:value={orgTitle} type="text" name="orgtitle" />
    </div>
  </div>

  <div class="rowtocol mb-4">
    <div class="col flex-1">
      <div class="form-label">Password *</div>
      <input bind:value={password} type="password" name="password" />
    </div>
    <div class="gutter" />
    <div class="col flex-1">
      <div class="form-label">Confirm Password *</div>
      <input bind:value={passwordConfirm} type="password" name="passwordconfirm" />
    </div>
  </div>

  <div class="row vcenter between" style="margin-top: 16px">
    <Link to="/signin">Already have an account?</Link>

    {#if loading}
      <div class='spinner' />
    {:else}
      <button type="submit" class="btn">SUBMIT</button>
    {/if}
  </div>
</form>

<style lang="scss">
@import '../util';
</style>